<template>
  <v-card>
    <v-card-title>
      <v-row align="center" class="mb-6">
        <!-- Botón de volver -->
        <v-col cols="auto">
          <v-btn
            v-if="!realTime"
            icon
            small
            color="primary"
            @click="$router.back()"
            title="Volver al menú"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </v-col>

        <!-- Título -->
        <v-col>
          <h2 class="text-h5 font-weight-bold primary--text">
            {{ title }}
          </h2>
        </v-col>
      </v-row>
      <v-spacer></v-spacer>
      <!-- <v-btn
        icon
        @click="close()"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn> -->
    </v-card-title>
    <v-card-text>
      <v-row v-if="!realTime">
        <v-col>
          <v-card>
            <v-card-text class="mb-2">
              <v-row>
                <v-col
                  cols="12"
                  md="5"
                >
                  <koiote-date-picker
                    dateLabel="Fecha Inicio"
                    hourLabel="Hora Inicio"
                    :type="1"
                  ></koiote-date-picker>
                </v-col>
                <v-col
                  cols="12"
                  md="5"
                >
                  <koiote-date-picker
                    dateLabel="Fecha Fin"
                    hourLabel="Hora Fin"
                    :type="2"
                  ></koiote-date-picker>
                </v-col>
                <v-col
                  cols="12"
                  md="2"
                  class="d-flex align-self-center"
                >
                  <v-btn
                    block
                    @click="addDataToVariable(1)"
                  >
                    Buscar
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <!-- Sidebar (10%) -->
        <!-- Contenido de la barra lateral -->
        <v-col
          v-if="!realTime"
          cols="3"
          class="sidebar"
        >
          <v-card class="scrollable-card">
            <v-card-title>Seleccionar variables</v-card-title>
            <v-card-text>
              <v-list>
                <v-list-item-group
                  v-model="selected_variables"
                  multiple
                  color="blue"
                  @change="addDataToVariable(2)"
                >
                  <v-list-item
                    v-for="(item, index) in available_variables"
                    :key="index"
                    :value="item"
                    :title="item?.description"
                  >
                    <v-list-item-title class="body-2 text-truncate">
                      {{ item?.description }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Main Content (90%) -->
        <v-col :cols="realTime ? 12 : 9">
          <!-- Contenido principal -->
          <v-card class="scrollable-card">
            <v-card-text>
              <template v-if="!selected_variables.length">
                <div>Seleccione al menos una variable para visualizar la gráfica.</div>
              </template>
              <template v-else-if="!loading && !computed_chart_data?.datasets?.length">
                <div>No se han encontrado datos para las fechas seleccionadas.</div>
              </template>
              <template v-else>
                <!-- Gráfica-->
                <v-row v-if="loading">
                  <v-col>
                    <v-progress-linear
                      indeterminate
                      color="primary"
                    ></v-progress-linear>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <line-chart
                      :chart-data="computed_chart_data"
                      @render-complete="onRenderComplete"
                    ></line-chart>
                  </v-col>
                </v-row>
                <!-- Gráfica acumulada (solo si no es analizador) -->
                <template v-if="!is_analizador && accumulatedChartData && !from_temp_view">
                  <v-row class="mt-6">
                    <v-col>
                      <h3 class="text-h6 font-weight-medium grey--text text--darken-1 mb-1">
                        📊 Acumulado
                      </h3>
                      <div class="mb-3">
                        <div v-for="(dataset, index) in accumulatedChartData.datasets" :key="index" class="text-caption grey--text">
                          {{ dataset.label }}: {{ getLastValue(dataset.data) }} L
                        </div>
                      </div>
                      <line-chart
                        :chart-data="accumulatedChartData"
                        @render-complete="onRenderComplete"
                      ></line-chart>
                    </v-col>
                  </v-row>
                </template>
                <!-- Tabla  con los datos -->
                <template v-if="!realTime && table_data?.length">
                  <v-row>
                    <v-col cols="9">
                      <h2>Detalles</h2>
                    </v-col>
                    <v-col cols="3">
                      <v-btn
                        dark
                        color="#da4726"
                        @click="downloadData()"
                      >
                        <v-icon class="mr-1">mdi-file-download</v-icon>
                        DESCARGAR
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-data-table
                        :headers="table_header"
                        :items="table_data"
                      >
                      </v-data-table>
                    </v-col>
                  </v-row>
                </template>
              </template>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from "moment-timezone";
import * as XLSX from "xlsx";

import { mapGetters, mapActions } from "vuex";

import LineChart from "@/components/utils/LineChart.vue";
import KoioteDatePicker from "@/components/utils/KoioteDatePicker.vue";

export default {
  components: {
    LineChart,
    KoioteDatePicker,
  },

  props: {
    title: String,
    realTime: Boolean,
    address: String,

    vars: Array,
    selected_var: Object,

    is_analizador: Boolean,

    topic_props: String,
    label: String,
  },

  data() {
    return {
      available_variables: [],
      selected_variables: [],

      chart_data: {},
      table_data: [],

      loading: true,

      from_temp_view: false,
    };
  },

  computed: {
    connection() {
      return this.actualPage()?.global_item_list?.find((gi) => gi.settings.component_type.includes("connection"))
        ?.customized;
    },

    computed_chart_data() {
      return this.realTime
        ? {
            datasets: [
              {
                data: this.getHistoryValues().map((d) => d.formatted_value),
                label: this.label ? this.label : this.selected_variables[0]?.description,
                backgroundColor: "#2b90c2",
                segment: { borderColor: "#2b90c2" },
                pointRadius: 0,
              },
            ],
            labels: this.getHistoryValues().reduce(function (timestamps, chartData) {
              if (!timestamps.includes(chartData.formatted_timestamp)) timestamps.push(chartData.formatted_timestamp);
              return timestamps;
            }, []),
          }
        : this.chart_data;
    },

    table_header() {
      if (this.is_analizador){
        return [
            { text: "Fecha", value: "date" },
            ...this.chart_data.datasets.map((data) => ({
              text: data.label,
              value: data.label
            }))
          ];
      } else {
        const headers = this.selected_variables?.map((v) => ({ text: `${v?.description}`, value: `${v?.id}` }));
        headers.unshift({ text: "Fecha", value: "read_at" });
        return headers;
      }
    },
    accumulatedChartData() {
      return this.computeAccumulatedData();
    },
    accumulatedTotal() {
      if (!this.accumulatedChartData?.datasets?.length) return 0;
      
      const total = this.accumulatedChartData.datasets.reduce((sum, ds) => {
        if (ds.data.length === 0) return sum;
        return sum + ds.data[ds.data.length - 1];
      }, 0);
      
      return parseFloat(total.toFixed(2));
    },
  },

  methods: {
    ...mapGetters(["actualPage"]),
    ...mapGetters("utils", ["getInitDateFilter", "getEndDateFilter"]),
    ...mapGetters("nodered", ["getHistoryValues"]),
    ...mapActions(["getData", "setSelectedPage", "loadPages", "getAnalizerData"]),

    getLastValue(data) {
      if (!data?.length) return 0;
      return parseFloat(data[data.length - 1].toFixed(2));
    },

    async addDataToVariable(origin) {
      this.loading = true;
      if (origin === 1) {
        this.chart_data = {};
        this.table_data = [];
      }

      if(this.is_analizador){
        const params = {
          variables: this.selected_variables,
          initDate: this.formattedDate(this.getInitDateFilter()),
          endDate: this.formattedDate(this.getEndDateFilter()),
        };

        let datasets = [];
        let labels = [];

        //recogemos los datos de cada variable en el tiempo dado
        for(let variable of params.variables){
          const output = {
            var: variable.formatted_address,
            begin: params.initDate,
            end: params.endDate,
            ip: variable.ip
          };
          const payload = {
            path:'get-xml',
            params: output
          }
  
          const data = await this.getAnalizerData(payload);
          const record = data.recordGroup.record;

          this.datos = record;
          datasets.push(this.transformData(record).datasets[0]);
          labels = this.transformData(record).labels
        };
        this.chart_data = {
          datasets: datasets,
          labels: labels
        }
        this.loading = false;

        //Crear el array de datos para mostrar en la tabla
        this.table_data = this.chart_data.labels.map((label, index) => {
          const row = { date: label };

          this.chart_data.datasets.forEach((dataset) => {
            row[dataset.label] = dataset.data[index];
          });

          return row;
        });

      }else {
        const params = {
          variables: JSON.stringify(this.selected_variables?.map((v) => v.id)),
          initDate: this.getInitDateFilter(),
          endDate: this.getEndDateFilter(),
        };
        //aqui añadir lo de los analizadores, si es analizador buscar en getanalizerdata
        const { table_data, ...chartData } = await this.getData({
          path: `variables/history/ts/chart`,
          params: params,
        });
  
        chartData.labels = chartData?.labels?.map((date) =>
          moment.tz(date, moment.tz.guess()).format("DD/MM/YYYY HH:mm:ss")
        );
  
        this.chart_data = chartData;
  
        this.table_data = table_data?.map((td) => ({
          ...td,
          read_at: moment.tz(td.read_at, moment.tz.guess()).format("DD/MM/YYYY HH:mm:ss"),
        }));
      }
    },
    computeAccumulatedData() {
      if (this.is_analizador || !this.chart_data.datasets?.length) return null;

      const labels = this.chart_data.labels;

      if (labels.length <= 1) {
        // Si no hay suficientes puntos, devolver datasets vacíos o nulos
        return {
          labels,
          datasets: this.chart_data.datasets.map(ds => ({
            label: `Integral de ${ds.label || 'serie'}`,
            data: [],
            borderColor: ds.backgroundColor || "#e91e63",
            backgroundColor: ds.backgroundColor || "rgba(233, 30, 99, 0.2)",
            fill: true,
            tension: 0.1,
            pointRadius: 0,
          }))
        };
      }

      // Convertir labels a timestamps en milisegundos (una sola vez)
      const timestamps = labels.map(label => 
        moment(label, "DD/MM/YYYY HH:mm:ss").valueOf()
      );

      // Validar timestamps
      for (let i = 0; i < timestamps.length; i++) {
        if (isNaN(timestamps[i])) {
          console.warn("Etiqueta de fecha inválida:", labels[i]);
          return null;
        }
      }

      // Procesar cada dataset
      const accumulatedDatasets = this.chart_data.datasets.map(dataset => {
        const data = dataset.data;

        if (data.length <= 1) {
          return {
            label: `Integral de ${dataset.label || 'serie'}`,
            data: data.length === 1 ? [parseFloat(data[0]) || 0] : [],
            borderColor: dataset.backgroundColor || "#e91e63",
            backgroundColor: dataset.backgroundColor || "rgba(233, 30, 99, 0.2)",
            fill: true,
            tension: 0.1,
            pointRadius: 0,
          };
        }

        // Calcular integral acumulada para este dataset
        const accData = [0];
        let integral = 0;

        for (let i = 1; i < data.length; i++) {
          const y0 = parseFloat(data[i - 1]) || 0;
          const y1 = parseFloat(data[i]) || 0;
          const dt = (timestamps[i] - timestamps[i - 1]) / 1000; // en segundos

          const area = ((y0 + y1) / 2) * dt;
          integral += area;
          accData.push(integral);
        }

        return {
          label: `Integral de ${dataset.label || 'serie'}`,
          data: accData,
          borderColor: dataset.backgroundColor || "#e91e63",
          backgroundColor: dataset.backgroundColor || "rgba(233, 30, 99, 0.2)",
          fill: true,
          tension: 0.1,
          pointRadius: 0,
        };
      });

      return {
        labels,
        datasets: accumulatedDatasets
      };
    },

    downloadData() {
      if (this.table_header.length > 1) {
        const ws = XLSX.utils.aoa_to_sheet([this.table_header?.map((header) => header.text)]);
        this.table_data.forEach((item) => {
          const row = this.table_header?.map((header) => (item[header.value] !== null ? item[header.value] : ""));
          XLSX.utils.sheet_add_aoa(ws, [row], { origin: -1 });
        });
        const wb = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(wb, ws, "Data");
        const file_name = "datos_variables_seleccionadas";
        XLSX.writeFile(wb, file_name + ".xlsx");
      }
    },

    transformData(data){
      return {
          labels: data.map(entry => {
            const dt = entry.dateTime;
            // Parsear la fecha en formato UTC
            const utcMoment = moment.utc(dt, "DDMMYYYYHHmm");
            
            // Convertir a hora local española (maneja CET/CEST automáticamente)
            const localMoment = utcMoment.tz("Europe/Madrid");
            
            // Formatear como "YYYY-MM-DD HH:mm"
            return localMoment.format("YYYY-MM-DD HH:mm");
          }),
          datasets: [
            {
              label: data[0].field.id,
              data: data.map(entry => parseFloat(entry.field.value)),
              borderColor: `rgba(${Math.floor(Math.random() * 256)},${Math.floor(Math.random() * 256)},${Math.floor(Math.random() * 256)},0.4)`,
              backgroundColor: `rgba(${Math.floor(Math.random() * 256)},${Math.floor(Math.random() * 256)},${Math.floor(Math.random() * 256)},0.4)`,
              fill: true,
              tension: 0.1,
            }
          ]
        };
    },

    formattedDate(date){
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const hours = String(d.getHours()).padStart(2, '0');
      const minutes = String(d.getMinutes()).padStart(2, '0');
      const seconds = String(d.getSeconds()).padStart(2, '0');
      return `${day}${month}${year}${hours}${minutes}${seconds}`;
    },

    close() {
      this.$emit("close");
    },

    onRenderComplete() {
      this.loading = false;
    },
  },

  async created() {
    if (this.$route.path.includes("/history")) {
      await this.loadPages();
      // this.setSelectedPage(this.$route.params.page_index);
    }

    //procesar  variables cuando se viene del apartado de temperaturas
    if (this.vars?.length > 0 && this.selected_var) {
      this.from_temp_view = true;
      //si son variables del analizador
      let variables;

      if (this.is_analizador) {
        // ✅ Caso 1: analizadores → ya tienes los datos
        variables = this.vars.map(v => ({
          id: v.id,
          ip: v.topic_read,
          formatted_address: `${v.alarm_address}.${v.var_address}`,
          description: v.description,
        }));
      } else {
        // ✅ Caso 2: temperaturas/humedades → necesitas llamar al backend
        const vars = this.vars.map(t => ({
          formatted_address: t.var_address,
          plc_id: t.type.id_plc
        }));

        const response = await this.getData({
          path: "variables/history/temps",
          params: { filters: JSON.stringify(vars) }
        });
        variables = response.variables;
      }
      this.available_variables = variables;

      if(this.selected_var){
        this.selected_variables = [ this.is_analizador ? 
        this.available_variables.find((v) => v.formatted_address == `${this.selected_var.alarm_address}.${this.selected_var.var_address}`)
        : this.available_variables.find((v) => v.formatted_address == this.selected_var.var_address && v.plc_id == this.selected_var.type.id_plc)];
        this.addDataToVariable(2);
      }
    }
    //procesar variables cuando se viene del resto de apartados
    else {
      const { variables } = await this.getData({
        path: "variables/history",
        params: { topicRead: this.topic_props ? this.topic_props : this.connection?.topic_read || "PLC0R" },
      });
      this.available_variables = variables;
      
      if (this.address) {
        this.selected_variables = [this.available_variables.find((v) => v.formatted_address == this.address)];
      }
    }

  },
};
</script>

<style>
.scrollable-card {
  max-height: 600px;
  overflow-y: auto;
}
</style>
